const COMBO_LENGTHS = {
  basic: { min: 4, max: 5 },
  advanced: { min: 5, max: 6 },
  pro: { min: 6, max: 7 },
  // A fallback for modes without specific lengths, like the old "combo" mode
  default: { min: 3, max: 3 },
};

function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function generateCombosForSet(level) {
  const { min, max } = COMBO_LENGTHS[level] || COMBO_LENGTHS.default;
  const length = getRandomInt(min, max);

  const primary = [{ type: "punch", side: "left" }];
  let consecutiveDodges = 0;

  while (primary.length < length) {
    const lastMove = primary[primary.length - 1];
    const oppositeSide = lastMove.side === "left" ? "right" : "left";

    // Dodge logic
    const dodgeChance = consecutiveDodges === 0 ? 3 : 2;
    if (consecutiveDodges < 2 && Math.random() < 1 / dodgeChance) {
      primary.push({ type: "dodge", side: oppositeSide });
      consecutiveDodges++;
    } else {
      // Punch logic
      primary.push({ type: "punch", side: oppositeSide });
      consecutiveDodges = 0;
    }
  }

  let mirrored = primary.map((move) => ({
    ...move,
    side: move.side === "left" ? "right" : "left",
  }));

  console.log("Generated Combos for set:", { primary, mirrored });
  return { primary, mirrored };
}
